/**
 * Configuration for enabling global performance dark read test. * Endpoints annotated @DarkReads will replicate extra traffic based on the configuration, optionally * reduced to a subset using the `PerfDarkReadsConfig.endpoints` regexp allowlist.
 */
export const PERF_DARK_READ_TESTING_ENABLED = 'PERF_DARK_READ_TESTING_ENABLED';
